import axios from 'axios';
import React, { createContext, useEffect, useState } from 'react'
import { ENDPOINT } from '../helpers/Helper';

export const CategoryContext = createContext();

function CategoryContextProvider(props) {

    const [categories, setCategories] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);

        axios.get(`${ENDPOINT}/categories`)
            .then(res => {
                setCategories(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.log(err.response.data.error);
                setLoading(false);
            })
    }, []);

    return (
        <CategoryContext.Provider value={{ categories }}>
            {props.children}
        </CategoryContext.Provider> 
       
    )
}

export default CategoryContextProvider
